module.exports = __webpack_public_path__ + "img/result_desk_ust.ec7a544b.jpg";